/**
 * Gift Wrapping Checker Custom Element
 * Automatically sets cart attribute when any of the specified gift wrapping SKUs are in cart
 */

class GiftWrappingChecker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.targetSkus = this.dataset.targetSkus
      ? this.dataset.targetSkus.split(',').map(sku => sku.trim())
      : []
    this.attributeKey = this.dataset.attributeKey
    this.attributeValue = this.dataset.attributeValue

    this.checkAndSetAttribute()
  }

  setupListeners () {
    super.setupListeners()

    this.handleCartChange = this.handleCartChange.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.handleCartChange,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.handleCartChange,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.handleCartChange,
    )
  }

  async handleCartChange (event) {
    // Small delay to ensure cart state is updated
    setTimeout(() => {
      this.checkAndSetAttribute()
    }, 100)
  }

  async checkAndSetAttribute () {
    try {
      const cart = await window.BAO.Cart.cartGet()
      const hasTargetSku = this.cartContainsTargetSku(cart)
      const currentGiftWrapping =
        cart.attributes && cart.attributes[this.attributeKey]

      // Only update if we need to change the attribute value
      if (hasTargetSku) {
        // Gift wrapping SKU is in cart - ensure attribute is set
        if (currentGiftWrapping !== this.attributeValue) {
          await this.setGiftWrappingAttribute(this.attributeValue)
        }
      } else {
        // No gift wrapping SKU in cart - ensure attribute is removed
        if (currentGiftWrapping && currentGiftWrapping !== '') {
          await this.setGiftWrappingAttribute('')
        }
      }
    } catch (error) {
      console.error('Error checking gift wrapping attribute:', error)
    }
  }

  cartContainsTargetSku (cart) {
    if (!cart.items || !Array.isArray(cart.items) || !this.targetSkus.length) {
      return false
    }

    return cart.items.some(item => {
      return this.targetSkus.includes(item.sku)
    })
  }

  async setGiftWrappingAttribute (value) {
    try {
      const attributes = {}
      attributes[this.attributeKey] = value

      await window.BAO.Cart.updateCartAttributes(attributes, {
        sections: [], // Don't reload sections, just update attributes
      })
    } catch (error) {
      console.error('Error updating cart attributes:', error)
    }
  }
}

if (!customElements.get('gift-wrapping-checker')) {
  customElements.define('gift-wrapping-checker', GiftWrappingChecker)
}
